import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withKeys as _withKeys, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/image.png'
import _imports_1 from '../../assets/image1.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-e2478aa8")

_pushScopeId("data-v-e2478aa8")
const _hoisted_1 = { style: {"flex":"1"} }
const _hoisted_2 = { style: {"box-sizing":"border-box","color":"black","padding":"20px 0"} }
const _hoisted_3 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_4 = {
  class: "collapse-content",
  style: {"padding":"20px"},
  key: "content"
}
const _hoisted_5 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_6 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_8 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { style: {"border-bottom":"2px solid #c1c1c1","flex-grow":"1"} }, null, -1)
const _hoisted_10 = { style: {"width":"32px","height":"32px"} }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { style: {"border-bottom":"2px solid #c1c1c1","flex-grow":"1"} }, null, -1)
const _hoisted_12 = { style: {"padding":"30px 30px","background":"#d1edff"} }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { style: {"display":"flex","justify-content":"space-between"} }, [
  /*#__PURE__*/_createVNode("h5", {
    id: "report_scroll",
    class: "TitleStyle"
  }, [
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createTextVNode("测试信息 ")
  ])
], -1)
const _hoisted_14 = { style: {"display":"flex"} }
const _hoisted_15 = { class: "no-bullet" }
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, "测试场景:", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "测试时间:", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "测试时长:", -1)
const _hoisted_19 = {
  class: "no-bullet",
  style: {"margin":"0 200px"}
}
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "机型:", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, "芯片:", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", null, "GPU:", -1)
const _hoisted_23 = { class: "no-bullet" }
const _hoisted_24 = /*#__PURE__*/_createVNode("span", null, "当前版本:", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("span", null, "对比版本:", -1)
const _hoisted_26 = { class: "testMain" }
const _hoisted_27 = /*#__PURE__*/_createVNode("textarea", { id: "input" }, "这是幕后黑手", -1)
const _hoisted_28 = { class: "module_djalog" }
const _hoisted_29 = { class: "dialog-content configurationStyle" }
const _hoisted_30 = { class: "form-items" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_32 = { class: "check_style" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("变差就有风险")
const _hoisted_34 = { class: "check_style" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 2,
  style: {"margin":"0 10px"}
}
const _hoisted_37 = /*#__PURE__*/_createTextVNode("启用基线")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("启用变化阈值")
const _hoisted_39 = { key: 1 }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("复制函数名")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("添加曲线")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("复制文本信息")
const _hoisted_49 = { class: "dialog-footer" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("关 闭")
const _hoisted_51 = /*#__PURE__*/_createVNode("div", { style: {"display":"flex","justify-content":"space-between"} }, [
  /*#__PURE__*/_createVNode("h5", {
    id: "report_scroll",
    class: "TitleStyle"
  }, [
    /*#__PURE__*/_createVNode("span"),
    /*#__PURE__*/_createTextVNode("全量函数耗时 ")
  ])
], -1)
const _hoisted_52 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("全部收起")
const _hoisted_55 = { style: {"width":"100%","height":"35px","display":"flex","position":"relative","border-radius":"2%"} }
const _hoisted_56 = { class: "pos_box" }
const _hoisted_57 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_58 = { style: {"width":"50%","margin-right":"20px"} }
const _hoisted_59 = { style: {"width":"5.5%"} }
const _hoisted_60 = { style: {"margin-left":"auto","width":"25%"} }
const _hoisted_61 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_62 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_63 = {
  key: 0,
  id: "chart",
  ref: "container"
}
const _hoisted_64 = { style: {"height":"400px","overflow-y":"auto"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode(_Transition, { name: "collapse" }, {
                  default: _withId(() => [
                    _withDirectives(_createVNode("div", _hoisted_4, [
                      _createVNode(_component_el_form, {
                        class: "anaysis_class",
                        inline: true,
                        size: "mini"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_5, [
                            _createVNode(_component_el_form_item, { label: "是否自动" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.auto_query,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.auto_query = $event)),
                                  placeholder: "请选择",
                                  multiple: "",
                                  onChange: _cache[2] || (_cache[2] = ($event: any) => (
                          _ctx.versionChange(false, ['type', 'scene', 'device'])
                        )),
                                  "collapse-tags": "",
                                  "collapse-tags-tooltip": ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.auto_data, (item, k) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: k,
                                        label: item.label,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            (_ctx.report_data.length != 1)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 0,
                                  label: "父类型"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      filterable: "",
                                      onChange: _cache[3] || (_cache[3] = ($event: any) => (
                          _ctx.versionChange(
                            false,
                            ['type', 'scene', 'device'],
                            (_ctx.subtype_query = '')
                          )
                        )),
                                      modelValue: _ctx.type_query,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.type_query = $event)),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.report_data, (item, k) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: k,
                                            label: item.name,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.report_data.length != 1)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 1,
                                  label: "子类型"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _cache[5] || (_cache[5] = ($event: any) => (
                          _ctx.versionChange(false, ['type', 'scene', 'device'])
                        )),
                                      key: _ctx.sub_key,
                                      filterable: "",
                                      modelValue: _ctx.subtype_query,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.subtype_query = $event)),
                                      placeholder: "请选择"
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sub_data, (item, k) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: k,
                                            label: item.name,
                                            value: item.value
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form, {
                        inline: true,
                        size: "mini",
                        class: "anaysis_class"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_6, [
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "场景"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.scene,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.dataConsumeOptions.scene = $event)),
                                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.versionChange(false, ['scene', 'device']))),
                                  placeholder: "请选择",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.scene_id,
                                        label: item.scene__chinese,
                                        value: item.scene_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "机型"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.device,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.dataConsumeOptions.device = $event)),
                                  onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.versionChange(false, ['device']))),
                                  placeholder: "请选择",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.device_options, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.device_id,
                                        label: 
                            item.device__level +
                            '档机-' +
                            item.device__model__name +
                            '-' +
                            item.device__model__model +
                            '-' +
                            item.device__UUID
                          ,
                                        value: item.device_id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "版本"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.version,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.dataConsumeOptions.version = $event)),
                                  placeholder: "请选择",
                                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.versionChange(true))),
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item.chinese,
                                        value: item.chinese
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, {
                              class: "version_input",
                              label: "对比版本"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.dataConsumeOptions.old_verson,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.dataConsumeOptions.old_verson = $event)),
                                  placeholder: "请选择",
                                  filterable: ""
                                }, {
                                  default: _withId(() => [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.versionsOldOptions, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item,
                                        label: item.chinese,
                                        value: item.chinese
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  onClick: _ctx.confirm,
                                  type: "primary"
                                }, {
                                  default: _withId(() => [
                                    _hoisted_7
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ], 512), [
                      [_vShow, _ctx.serchDataShow]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode("div", _hoisted_10, [
                    (!_ctx.serchDataShow)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          style: {"width":"100%","height":"100%"},
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.openBtn && _ctx.openBtn(...args))),
                          src: _imports_0,
                          alt: ""
                        }))
                      : (_openBlock(), _createBlock("img", {
                          key: 1,
                          style: {"width":"100%","height":"100%"},
                          onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.openBtn && _ctx.openBtn(...args))),
                          src: _imports_1,
                          alt: ""
                        }))
                  ]),
                  _hoisted_11
                ]),
                _withDirectives(_createVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, [
                    _createVNode("ul", _hoisted_15, [
                      _createVNode("li", null, [
                        _hoisted_16,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.scene), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_17,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.tiemline), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_18,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.duration), 1)
                      ])
                    ]),
                    _createVNode("ul", _hoisted_19, [
                      _createVNode("li", null, [
                        _hoisted_20,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.device_level +
                      "-" +
                      _ctx.report_data_list?.device_name), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_21,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.cpu_name), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_22,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.gpu_name), 1)
                      ])
                    ]),
                    _createVNode("ul", _hoisted_23, [
                      _createVNode("li", null, [
                        _hoisted_24,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.version), 1)
                      ]),
                      _createVNode("li", null, [
                        _hoisted_25,
                        _createTextVNode(_toDisplayString(_ctx.report_data_list?.old_version), 1)
                      ])
                    ])
                  ])
                ], 512), [
                  [_directive_loading, _ctx.report_text_show]
                ]),
                _createVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode("div", _hoisted_28, [
                    _createVNode(_component_el_dialog, {
                      modelValue: _ctx.configurationShow,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.configurationShow = $event)),
                      width: "70%",
                      class: "custom-dialog",
                      height: "auto"
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_29, [
                          _createVNode(_component_el_form, {
                            inline: true,
                            size: "mini"
                          }, {
                            default: _withId(() => [
                              _createVNode("div", _hoisted_30, [
                                _createVNode(_component_el_form_item, { label: "选择场景" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _ctx.configChange,
                                      modelValue: _ctx.configuration_form.scene_id,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.configuration_form.scene_id = $event)),
                                      placeholder: "请选择",
                                      filterable: ""
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scene_options_old_table, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.scene_id,
                                            label: item.scene__chinese,
                                            value: item.scene_id
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "选择平台" }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_select, {
                                      onChange: _ctx.configChange,
                                      modelValue: _ctx.configuration_form.moudle,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.configuration_form.moudle = $event)),
                                      placeholder: "选择平台",
                                      filterable: ""
                                    }, {
                                      default: _withId(() => [
                                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.moudle, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item,
                                            label: item,
                                            value: item
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["onChange", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createVNode(_component_el_form_item, { class: "save-button" }, {
                                default: _withId(() => [
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.save_button
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_31
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode("div", _hoisted_32, [
                            _createVNode(_component_el_checkbox, {
                              onChange: _cache[18] || (_cache[18] = ($event: any) => (
                          _ctx.is_bad_risk == true
                            ? (_ctx.threshold_check = false)
                            : (_ctx.threshold_check = _ctx.threshold_check)
                        )),
                              modelValue: _ctx.is_bad_risk,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.is_bad_risk = $event))
                            }, {
                              default: _withId(() => [
                                _hoisted_33
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _createVNode("div", _hoisted_34, [
                            (!_ctx.baseline_check)
                              ? (_openBlock(), _createBlock("span", _hoisted_35, "添加基线列"))
                              : (_openBlock(), _createBlock("span", {
                                  key: 1,
                                  style: {"color":"#409eff","cursor":"pointer"},
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.addRow_baseline()))
                                }, "添加基线列")),
                            (!_ctx.threshold_check)
                              ? (_openBlock(), _createBlock("span", _hoisted_36, "添加变化阈值列"))
                              : (_openBlock(), _createBlock("span", {
                                  key: 3,
                                  style: {"margin":"0 10px","color":"#409eff","cursor":"pointer"},
                                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.addRow_threshold()))
                                }, "添加变化阈值列")),
                            _createVNode(_component_el_checkbox, {
                              modelValue: _ctx.baseline_check,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.baseline_check = $event))
                            }, {
                              default: _withId(() => [
                                _hoisted_37
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_checkbox, {
                              disabled: _ctx.is_bad_risk,
                              modelValue: _ctx.threshold_check,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.threshold_check = $event))
                            }, {
                              default: _withId(() => [
                                _hoisted_38
                              ]),
                              _: 1
                            }, 8, ["disabled", "modelValue"])
                          ]),
                          _createVNode(_component_el_table, {
                            border: "",
                            size: "mini",
                            "header-cell-style": {
                        background: '#5D99D5',
                        color: '#fff',
                      },
                            "cell-style": _ctx.cellStyle2,
                            data: _ctx.configuration_table_data
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_table_column, {
                                width: "120",
                                label: "指标"
                              }, {
                                default: _withId((scope) => [
                                  (
                              scope.$index == 5 &&
                              (_ctx.baseline_check || _ctx.threshold_check)
                            )
                                    ? (_openBlock(), _createBlock(_component_el_input, {
                                        key: 0,
                                        modelValue: scope.row.name,
                                        "onUpdate:modelValue": ($event: any) => (scope.row.name = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    : (_openBlock(), _createBlock("span", _hoisted_39, _toDisplayString(scope.row.name), 1))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, { label: "基线" }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.configuration_table_baseline, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      width: "150",
                                      key: index
                                    }, {
                                      header: _withId(() => [
                                        (!_ctx.baseline_check)
                                          ? (_openBlock(), _createBlock("div", _hoisted_40, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (i) => {
                                                return (_openBlock(), _createBlock("span", {
                                                  style: 
                                  'margin-right:10px;display: inline-block;padding:0px 5px;background:' +
                                  _ctx.gear_position.filter((c) => c.value == i)[0]
                                    ?.background
                                ,
                                                  key: i
                                                }, _toDisplayString(_ctx.gear_position.filter((c) => c.value == i)[0]
                                    ?.name), 5))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createBlock(_component_el_select, {
                                              key: 1,
                                              modelValue: item.value,
                                              "onUpdate:modelValue": ($event: any) => (item.value = $event),
                                              placeholder: "请选择",
                                              multiple: "",
                                              size: "mini",
                                              "collapse-tags": "",
                                              "collapse-tags-tooltip": ""
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.determine(
                                  _ctx.configuration_table_baseline,
                                  _ctx.gear_position_all,
                                  index
                                ), (item, k) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: k,
                                                    label: item.name,
                                                    value: item.value,
                                                    disabled: item.disabled
                                                  }, null, 8, ["label", "value", "disabled"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                      ]),
                                      default: _withId((scope) => [
                                        (!_ctx.baseline_check && scope.row.name != '')
                                          ? (_openBlock(), _createBlock("span", _hoisted_41, _toDisplayString(scope.row.baseline[index]), 1))
                                          : (
                                !_ctx.baseline_check && scope.row.name === ''
                              )
                                            ? (_openBlock(), _createBlock("span", _hoisted_42, _toDisplayString(scope.row.baseline[index]), 1))
                                            : (_ctx.baseline_check && scope.row.name != '')
                                              ? (_openBlock(), _createBlock(_component_el_input, {
                                                  key: 2,
                                                  modelValue: scope.row.baseline[index],
                                                  "onUpdate:modelValue": ($event: any) => (scope.row.baseline[index] = $event)
                                                }, {
                                                  default: _withId(() => [
                                                    _createTextVNode(_toDisplayString(scope.row.baseline[index]), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                              : (_ctx.baseline_check && scope.row.name == '')
                                                ? (_openBlock(), _createBlock("span", {
                                                    key: 3,
                                                    style: {"color":"#409eff","cursor":"pointer"},
                                                    onClick: ($event: any) => (_ctx.delete_baseline(index))
                                                  }, _toDisplayString(scope.row.baseline[index]), 9, ["onClick"]))
                                                : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_table_column, { label: "变化阈值" }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.configuration_table_threshold, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_el_table_column, {
                                      width: "150",
                                      key: index
                                    }, {
                                      header: _withId(() => [
                                        (!_ctx.threshold_check)
                                          ? (_openBlock(), _createBlock("div", _hoisted_43, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.value, (i) => {
                                                return (_openBlock(), _createBlock("span", {
                                                  style: 
                                  'margin-right:10px;display: inline-block;padding:0px 5px;background:' +
                                  _ctx.gear_position.filter((c) => c.value == i)[0]
                                    .background
                                ,
                                                  key: i
                                                }, _toDisplayString(_ctx.gear_position.filter((c) => c.value == i)[0]
                                    .name), 5))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createBlock(_component_el_select, {
                                              key: 1,
                                              modelValue: item.value,
                                              "onUpdate:modelValue": ($event: any) => (item.value = $event),
                                              placeholder: "请选择",
                                              multiple: "",
                                              size: "mini",
                                              "collapse-tags": "",
                                              "collapse-tags-tooltip": ""
                                            }, {
                                              default: _withId(() => [
                                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.determine(
                                  _ctx.configuration_table_threshold,
                                  _ctx.gear_position_all_threshold,
                                  index
                                ), (item, k) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: k,
                                                    label: item.name,
                                                    value: item.value,
                                                    disabled: item.disabled
                                                  }, null, 8, ["label", "value", "disabled"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                      ]),
                                      default: _withId((scope) => [
                                        (!_ctx.threshold_check && scope.row.name != '')
                                          ? (_openBlock(), _createBlock("span", _hoisted_44, _toDisplayString(scope.row.threshold[index]), 1))
                                          : (
                                !_ctx.threshold_check && scope.row.name == ''
                              )
                                            ? (_openBlock(), _createBlock("span", _hoisted_45, _toDisplayString(scope.row.threshold[index]), 1))
                                            : (
                                _ctx.threshold_check && scope.row.name != ''
                              )
                                              ? (_openBlock(), _createBlock(_component_el_input, {
                                                  key: 2,
                                                  modelValue: scope.row.threshold[index],
                                                  "onUpdate:modelValue": ($event: any) => (scope.row.threshold[index] = $event)
                                                }, {
                                                  default: _withId(() => [
                                                    _createTextVNode(_toDisplayString(scope.row.threshold[index]), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                              : (
                                _ctx.threshold_check && scope.row.name == ''
                              )
                                                ? (_openBlock(), _createBlock("span", {
                                                    key: 3,
                                                    onClick: ($event: any) => (_ctx.delete_threshold(index)),
                                                    style: {"color":"#409eff","cursor":"pointer"}
                                                  }, _toDisplayString(scope.row.threshold[index]), 9, ["onClick"]))
                                                : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["cell-style", "data"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_el_dialog, {
                    width: "615px",
                    modelValue: _ctx.tootip_flame,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.tootip_flame = $event))
                  }, {
                    footer: _withId(() => [
                      _createVNode("span", _hoisted_49, [
                        _createVNode(_component_el_button, {
                          size: "small",
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.tootip_flame = false)),
                          type: "info"
                        }, {
                          default: _withId(() => [
                            _hoisted_50
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withId(() => [
                      _createVNode(_component_el_form, {
                        inline: true,
                        size: "mini",
                        "label-position": "top"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_form_item, { style: {"width":"150px"} }, {
                            default: _withId(() => [
                              _createVNode(_component_el_button, {
                                size: "small",
                                type: "primary",
                                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.copyName(_ctx.functionName)))
                              }, {
                                default: _withId(() => [
                                  _hoisted_46
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { style: {"width":"150px"} }, {
                            default: _withId(() => [
                              _createVNode(_component_el_button, {
                                size: "small",
                                type: "primary",
                                onClick: _ctx.addline
                              }, {
                                default: _withId(() => [
                                  _hoisted_47
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, { style: {"width":"150px"} }, {
                            default: _withId(() => [
                              _createVNode(_component_el_button, {
                                size: "small",
                                type: "primary",
                                onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.copyName(_ctx.tooltip_text)))
                              }, {
                                default: _withId(() => [
                                  _hoisted_48
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode("div", null, [
                    _hoisted_51,
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_52, [
                        _createVNode(_component_el_form, {
                          inline: true,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  size: "mini",
                                  onClick: _ctx.submit
                                }, {
                                  default: _withId(() => [
                                    _hoisted_53
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  onKeyup: _withKeys(_ctx.serchChange_enter, ["enter"]),
                                  modelValue: _ctx.inputValue,
                                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.inputValue = $event))
                                }, null, 8, ["onKeyup", "modelValue"])
                              ]),
                              _: 1
                            }),
                            _withDirectives(_createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  type: "text",
                                  onKeyup: _withKeys(_ctx.serchChange_enter, ["enter"]),
                                  modelValue: _ctx.inputValue,
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.inputValue = $event))
                                }, null, 8, ["onKeyup", "modelValue"])
                              ]),
                              _: 1
                            }, 512), [
                              [_vShow, false]
                            ]),
                            _createVNode(_component_el_form_item, null, {
                              default: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.close1(_ctx.stackData, _ctx.state)))
                                }, {
                                  default: _withId(() => [
                                    _hoisted_54
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _withDirectives(_createVNode(_component_el_table, {
                        id: "func",
                        border: "",
                        class: "customer-table2",
                        onRowClick: _ctx.handleRowClick,
                        "default-expand-all": _ctx.isExpand,
                        data: _ctx.stackData_all,
                        size: "small",
                        "header-cell-style": {
                      background: '#1B1B1B',
                      color: '#B5B5B5',

                      padding: '1px,0',
                      height: '10px',
                    },
                        ref: "table",
                        style: {"width":"100%","margin-bottom":"20px"},
                        "row-key": "id"
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_el_table_column, {
                            "show-overflow-tooltip": true,
                            label: "func_name",
                            width: "700",
                            fixed: "left"
                          }, {
                            default: _withId((scope) => [
                              _createVNode("span", null, _toDisplayString(scope.row.name), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            "show-overflow-tooltip": true,
                            label: "耗时(ms)"
                          }, {
                            default: _withId((scope) => [
                              _createVNode("span", null, _toDisplayString(scope.row.value.toFixed(2)), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "占比",
                            width: "150"
                          }, {
                            default: _withId((scope) => [
                              _createVNode("div", _hoisted_55, [
                                _createVNode("div", {
                                  style: 
                              'height:35px;background: linear-gradient(to right, #8AAAD4, white);;width:' +
                              scope.row.rate +
                              '%'
                            
                                }, null, 4),
                                _createVNode("div", {
                                  style: 
                              'height:35px;background:#fff;width:' +
                              (100 - Number(scope.row.rate)) +
                              '%'
                            
                                }, null, 4),
                                _createVNode("div", _hoisted_56, _toDisplayString(scope.row.rate + "%"), 1)
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            label: "对比上版本(ms)",
                            align: "center",
                            width: "150"
                          }, {
                            default: _withId((scope) => [
                              _createVNode("div", null, _toDisplayString(_ctx.diffValue(
                              scope.row.value,
                              _ctx.func_list[scope.row.id]?.old_value
                            )), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_table_column, {
                            align: "center",
                            label: "平均耗时(ms)"
                          }, {
                            default: _withId((scope) => [
                              _createVNode("span", null, _toDisplayString(_ctx.func_list[scope.row.id]?.value
                            ? _ctx.func_list[scope.row.id]?.value.toFixed(2)
                            : ""), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onRowClick", "default-expand-all", "data"]), [
                        [_directive_loading, _ctx.moudle_loading]
                      ])
                    ]),
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_57, [
                        _createVNode("div", _hoisted_58, [
                          _createVNode(_component_el_input, {
                            size: "mini",
                            modelValue: _ctx.func_name,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.func_name = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_59, [
                          _createVNode(_component_el_input, {
                            size: "mini",
                            modelValue: _ctx.func_rate,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.func_rate = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_60, [
                          _createVNode("div", _hoisted_61, [
                            _createVNode(_component_el_input, {
                              style: {"margin-right":"20px"},
                              modelValue: _ctx.flame_serch,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.flame_serch = $event)),
                              placeholder: "搜索",
                              "prefix-icon": "el-icon-search",
                              size: "mini"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "mini",
                              onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.recordSearch()))
                            }, {
                              default: _withId(() => [
                                _hoisted_62
                              ]),
                              _: 1
                            })
                          ])
                        ])
                      ]),
                      (_ctx.flameShow)
                        ? (_openBlock(), _createBlock("div", _hoisted_63, [
                            _withDirectives(_createVNode(_component_el_tabs, {
                              type: "card",
                              class: "demo-tabs spacName tabs_color",
                              modelValue: _ctx.flame_name,
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.flame_name = $event)),
                              onTabClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.handleClick_flame(_ctx.flame_name)))
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.flame_thead_list, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_tab_pane, {
                                    key: item,
                                    label: item,
                                    name: item,
                                    style: {"padding":"10px"}
                                  }, {
                                    default: _withId(() => [
                                      _createVNode("div", _hoisted_64, [
                                        _createVNode("div", {
                                          id: _ctx.replaceSpacesWithHyphens(item),
                                          class: "chart-area"
                                        }, null, 8, ["id"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "name"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"]), [
                              [_directive_loading, _ctx.flame_tabs_show]
                            ])
                          ], 512))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})